<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import HeaderImage from '@/components/project/HeaderImage.vue'
import ProjectDialog from '@/components/project/ProjectDialog.vue'
import ProjectIndex from '@/components/project/ProjectIndex.vue'
import ProjectDeleteDialog from '@/components/project/ProjectDeleteDialog.vue'
import ProjectIndexTitle from '@/components/project/ProjectIndexTitle.vue'
import { AppBackground } from '@haskoning/vue-component-library'

const store = useStore()

const projects = computed(() => store.state.project.projects)

const fetchProjects = () => store.dispatch('project/fetchProjects')
const setCurrentTab = (payload) => store.dispatch('comment/setCurrentTab', payload)
const toggleShow = (payload) => store.dispatch('comment/toggleShow', payload)

const loading = computed(() => store.state.project.loading)

onMounted(async () => {
  await store.dispatch('resetAllStates')
  toggleShow(false)
  await setCurrentTab(null)
  if (!projects.value || !projects.value.length) {
    await fetchProjects()
  }
})
</script>

<template>
  <div class="fill-height pa-0" style="display: flex; flex-direction: column">
    <HeaderImage />
    <AppBackground class="px-8 py-4">
      <template v-if="loading">
        <div class="d-flex justify-center align-center fill-height">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </div>
      </template>
      <template v-else>
        <ProjectIndexTitle />
        <ProjectIndex class="mt-6" />
      </template>
    </AppBackground>
    <ProjectDialog></ProjectDialog>
    <ProjectDeleteDialog></ProjectDeleteDialog>
  </div>
</template>
